import { Spinner } from "views/mobile/components/common";
import { isLight } from "lib/color";
import React from "reactn";
import styled from "styled-components";

export const LoginButton = ({
	stroke = "#4a90e2",
	fill = "#fff",
	onClick,
	label,
	icon: Icon,
	loading,
	disabled,
}) => {
	const light = isLight(fill);
	return (
		<Button
			onClick={disabled || loading ? null : onClick}
			stroke={stroke}
			fill={disabled ? "grey" : fill}
			loading={loading}
		>
			{loading ? (
				<Spinner
					color={light ? stroke : "#fff"}
					button
					size={"small"}
				/>
			) : (
				label
			)}
			{!loading && Icon && <Icon />}
		</Button>
	);
};

const Button = styled.div`
	cursor: pointer;
	border-radius: 15px;
	border-style: solid;
	border-width: 1px;
	border-color: ${(p) => p.stroke};
	background-color: ${(p) => p.fill};
	background-image: url(${(p) => p.icon});
	background-position: 5%;
	font-weight: 600;
	color: ${(p) => p.stroke};
	padding: 5px 0 5px 0;
	text-align: center;
	width: 100%;
	position: relative;

	svg {
		position: absolute;
		left: 22px;
		top: 9px;
	}

	@media screen and (min-width: 767px) {
		& {
		}
	}
`;
